<template>
  <div>
    <div v-if="publicMessages.length && !loading" class="my-1">
      <v-alert
        v-for="(messageObj, index) in publicMessages"
        :key="messageObj.message + '_' + index"
        class="mt-2 mb-2 mx-2 flex-grow-1 text-center"
        color="warning"
        density="compact"
        type="info"
        ><span
          v-safe-html="
            `${moment(messageObj.updatedAt)}: ${messageObj.message}`
          "
      /></v-alert>
    </div>
    <div v-if="is_development()">
      <v-alert
        key="localhost_warning"
        class="mt-2 mb-2 mx-2 flex-grow-1 text-center"
        color="warning"
        density="compact"
        type="info"
      >
        You are using dev-api.fairsharing.org. Changes will not appear in
        production and will be lost when this server is updated.
      </v-alert>
    </div>
    <div v-if="is_localhost()">
      <v-alert
        key="dev_server_warning"
        class="mt-2 mb-2 mx-2 flex-grow-1 text-center"
        color="warning"
        density="compact"
        type="info"
      >
        You are using localhost. Changes will not appear in production and will
        be lost when this server is updated.
      </v-alert>
    </div>
  </div>
</template>

<script>
// no-v-html allowed as the text will come only from super_curators...
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "PublicMessages",
  computed: {
    ...mapState("messages", ["publicMessages", "loading"]),
  },
  methods: {
    moment(date) {
      return moment(date).format("dddd, MMMM Do YYYY, H:mm");
    },
    is_development() {
      const endpoint = import.meta.env.VITE_API_ENDPOINT || "";
      if (endpoint.includes("dev-api")) {
        return true;
      }
      return false;
    },
    is_localhost() {
      const endpoint = import.meta.env.VITE_API_ENDPOINT || "";
      if (
        endpoint.includes("localhost:3000") ||
        endpoint.includes("127.0.0.1:3000")
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped></style>
